
  import React from "react"
  import Component from "/Users/tero.alen/Dev/ajantasalla/src/layouts/index.js"
  import data from "/Users/tero.alen/Dev/ajantasalla/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js